import { render, staticRenderFns } from "./PayablesTable.vue?vue&type=template&id=b078347a&"
import script from "./PayablesTable.vue?vue&type=script&lang=js&"
export * from "./PayablesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports